import ForgotPasswordEmailFormContainer from './ForgotPasswordEmailFormContainer';

export default ForgotPasswordEmailFormContainer;
